document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".content-hub-faq button");

  function toggleFaq(item) {
    const isExpanded = item.getAttribute("aria-expanded") === "true";
    items.forEach((i) => i.setAttribute("aria-expanded", "false"));
    if (!isExpanded) item.setAttribute("aria-expanded", "true");
  }

  items.forEach((item) =>
    item.addEventListener("click", () => toggleFaq(item))
  );
});
